<template>
    
    <div>
        <div v-if="file">
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                ملف محضر الجلسة الإدارية {{ data ? data.meeting_minutes_label : ''  }} {{ message }}
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:file  } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </div> 
        
        <div v-else>
            <info-card
            :label="`رقم محضر الجلسة الإدارية ${message}`"
            :value="data ? data.meeting_minutes_label :''"
            />
        </div>  
    </div>
  </template>
  
  <script>
  
    import axios from "@axios";
  import { VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  import router from "@/router";
  export default {
    data() {
        return {
            file: '',
        }
    },
    components: {
      InfoCard , BButton
    },
    props: {
        data : Object ,
        message: String,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
    methods :{

        async handleDataChange(data) {
            
            const currentRoute = router.currentRoute.path.includes('ministry')
            if(currentRoute){
                await axios.get(`v2/ministry/ngo-meeting-minutes/${this.data.id}`).then((res) => this.file=res.data.data.file);
            }
            else{
                this.file=null
            }

        }
    },
    
    async mounted() {  
        this.handleDataChange(this.data)
    },  
    watch: {
        data: {
        handler: async function(newVal, oldVal) {
            await this.handleDataChange(this.data)
        },
        deep: true
        }
    },
  };
  </script>